import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { checkMediaQuery } from '../../utils/responsive'
import mediaQueries from '../../constants/mediaQueries'

export default function Hidden(props) {
	const {
		children,
		only,
		lgUp = false,
		lgDown = false,
		mdDown = false,
		mdUp = false,
		smDown = false,
		smUp = false
	} = props

	const [visible, setVisibility] = useState(true)

	function handleVisibility() {
		let canHidden = false

		// `only` check is faster to get out sooner if used.
		if (only) {
			if (Array.isArray(only)) {
				for (let i = 0; i < only.length; i++) {
					const mq = only[i]

					if (checkMediaQuery(mq)) {
						canHidden = true
						break
					}
				}
			} else {
				canHidden = checkMediaQuery(only)
			}
		}

		// Allow `only` to be combined with other props. If already hidden, no need to check others.
		if (!canHidden) {
			// determine visibility based on the smallest size up
			for (const mediaQuery in mediaQueries) {
				const breakpointUp = smUp || mdUp || lgUp ? props[`${mediaQuery}Up`] : null
				const breakpointDown = smDown || mdDown || lgDown ? props[`${mediaQuery}Down`] : null

				if (
					(breakpointUp && checkMediaQuery(mediaQuery, 'min')) ||
					(breakpointDown && checkMediaQuery(mediaQuery, 'max'))
				) {
					canHidden = true
					break
				}
			}
		}

		setVisibility(!canHidden)
	}

	useEffect(() => {
		window.addEventListener('resize', handleVisibility)

		handleVisibility()

		return () => {
			setVisibility(true)
		}
	}, [])

	if (!visible) {
		return null
	}

	return children
}

Hidden.propTypes = {
	/**
	 * The content of the component.
	 */
	children: PropTypes.node,
	/**
	 * If `true`, screens this size and down are hidden.
	 */
	lgDown: PropTypes.bool,
	/**
	 * If `true`, screens this size and up are hidden.
	 */
	lgUp: PropTypes.bool,
	/**
	 * If `true`, screens this size and down are hidden.
	 */
	mdDown: PropTypes.bool,
	/**
	 * If `true`, screens this size and up are hidden.
	 */
	mdUp: PropTypes.bool,
	/**
	 * Hide the given breakpoint(s).
	 */
	only: PropTypes.oneOfType([
		PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
		PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))
	]),
	/**
	 * If `true`, screens this size and down are hidden.
	 */
	smDown: PropTypes.bool,
	/**
	 * If `true`, screens this size and up are hidden.
	 */
	smUp: PropTypes.bool
}
